/** The glass chrome over the 3D deck. */

import type { Component } from 'solid-js';
import styles from './Hud.module.css';
import { NowPlaying } from './NowPlaying.tsx';
import { Rail } from './Rail.tsx';
import { Readout } from './Readout.tsx';
import { Toasts } from './Toasts.tsx';
import { TopBar } from './TopBar.tsx';
import { YouTubeCard } from './YouTubeCard.tsx';

export const Hud: Component = () => (
  <div class={styles.hud} data-hud>
    <TopBar />
    <Rail />
    <NowPlaying />
    <YouTubeCard />
    <Readout />
    <Toasts />
  </div>
);
